if (!customElements.get('bewo-poltrona-episodes')) {
  class BewoPoltronaEpisodes extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = false;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector('.bewo-poltrona-episodes__items');
      this.gap = Number(this.dataset.gap || 20);
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.slides = Array.from(this.querySelectorAll('.bewo-poltrona-episodes__slide'));

      if (!this.enableSlider || this.slides.length <= 1) return;

      this.initSlider();
    }

    disconnectedCallback() {
      if (typeof this.sliderInstance === 'object' && this.sliderInstance?.slider) {
        this.sliderInstance.slider.destroy(true, true);
        this.sliderInstance = false;
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;
      if (!window.BewoTheme?.Carousel) return;

      this.classList.add('swiper');
      this.sliderWrapper?.classList.add('swiper-wrapper');

      this.sliderInstance = new window.BewoTheme.Carousel(this, {
        slidesPerView: 'auto',
        spaceBetween: this.gap,
        loop: false,
        speed: 650,
        threshold: 4,
        watchOverflow: true,
        centeredSlides: false,
        slideToClickedSlide: false,
        navigation: {
          nextEl: this.section?.querySelector('.bewo-poltrona-episodes__nav--next'),
          prevEl: this.section?.querySelector('.bewo-poltrona-episodes__nav--prev'),
        },
      });

      this.sliderInstance.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    onBlockSelect = (event) => {
      if (event.detail.sectionId !== this.sectionId) return;
      const index = Number(event.target.closest('[data-index]')?.dataset.index);
      if (Number.isNaN(index) || !this.sliderInstance?.slider) return;
      this.sliderInstance.slider.slideTo(index);
    };
  }

  customElements.define('bewo-poltrona-episodes', BewoPoltronaEpisodes);
}
